exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#label-management .head[data-v-8aa2416c]  .el-input{width:200px}#label-management[data-v-8aa2416c]  .el-card__body{height:100%}", ""]);

// exports
